import { render, staticRenderFns } from "./appointment-list.vue?vue&type=template&id=188eb3e5"
import script from "./appointment-list.vue?vue&type=script&lang=js"
export * from "./appointment-list.vue?vue&type=script&lang=js"
import style0 from "./appointment-list.vue?vue&type=style&index=0&id=188eb3e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports